/*
 * AppAuthenticators Enums
 *
 * Update this file (and remove this line), or delete the file if not needed.
 *
 * Reminder:
 * enum name should use TitleCase and end with 'Enum'
 * enum keys should use TitleCase
 *
 */

export enum DatesDropdownEnum {
  Today = "Today",
  LastWeek = "Last week",
  ThisMonth = "This month",
  CustomDateRange = "Custom date range...",
}

export enum PassCodeSubmissionStatusEnum {
  INITIATE = "INITIATE",
  DONE = "DONE",
  ERROR = "ERROR",
  PROCESSING = "PROCESSING",
}

export enum AuthenticatorStatusEnum {
  INITIAL = "INITIAL",
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
  ERROR = "ERROR",
  PROCESSING = "PROCESSING",
}

export enum AppTypeEnum {
  APP = "app",
}
